export default __webpack_public_path__ + "static/media/location_preview_s6_pearopolis.79276321.svg";